import utils from './utils';

export default {
  index: state => page => state.schemes[page]['list']['lookups'],

  schema: state => params => {
    const ret = state.schemes[params.page] ? state.schemes[params.page][params.mode] : null;
    return ret;
  },

  subPages: state => page => {
    const pageScheme = state.schemes[page];

    if (!pageScheme || !Object.keys(pageScheme).length || !pageScheme.subPages) {
      return null;
    }

    return Array.isArray(pageScheme.subPages) ? pageScheme.subPages : pageScheme.subPages.pages;
  },

  subPageOf: state => page => {
    const result = state.schemes[page].subPageOf;
    return result;
  },

  siblingsSubPages: (state, getters) => page => {
    // recuperar a pagina pai
    const subPageOf = getters.subPageOf(page);
    if (!subPageOf) return [];
    // pegar as sub-paginas
    const subPages = getters.subPages(subPageOf);
    if (Array.isArray(subPages) == false) return [];
    // filtrar as paginas irmãs, ou seja todas as subpaginas menos a atual
    return subPages.filter(sb => sb.name !== page);
  },

  hasActionShared: (state, getters) => (page, mode) => {
    // Se a action clicada não estiver em multipage, retorna false
    if (!getters.subPageOf(page)) {
      return false;
    }

    // Recupera as actions do schema
    const action = getters.actions_scheme({ page, mode });
    let groupAction = null;

    // Caso exista actions em groups
    if (state.schemes[page][mode].groups) {
      groupAction = utils.getGroupButtons(state, { page, mode });
    }

    let groupActionContainsExecutePageActions,
      actionContainsExecutePageActions = false;

    // Retorna verdadeiro se caso exista action com atributos executePageActions
    actionContainsExecutePageActions =
      Array.isArray(action.items) && action.items.some(item => item.executePageActions === true);
    groupActionContainsExecutePageActions =
      Array.isArray(groupAction) &&
      groupAction.some(itemAction => itemAction.items.some(item => item.executePageActions === true));

    return actionContainsExecutePageActions || groupActionContainsExecutePageActions;
  },

  title: state => page => state.schemes[page].title,

  mainTitle: state => page => state.schemes[page].mainTitle,

  showBreadcrumbs: state => page => state.schemes[page].breadcrumbs,

  breadcrumbsFlat: state => page => state.schemes[page].breadcrumbsFlat,

  mode: state => id => state.schemes[id].default,

  loaded: state => id => state.schemes[id] ? true : false,

  mainPage: state => state.main,

  actions: state => params => state.schemes[params.page].list.recordActions[params.key],

  currentStep: state => page => {
    // return (state.defaultFilter[page] ? page['nr_step'] : undefined)
    return page ? page['nr_step'] : undefined;
  },

  entryModel: state => (page, mode) => {
    if (state.models[page]) {
      if (state.models[page][mode]) return state.models[page][mode];
    }
    return {};
  },

  parents: state => page => state.parents[page],

  // Garantindo que state.schemes[page] existe antes de verificar se a propriedade
  // 'list' está presente.
  // Correção para evitar TypeError: Cannot use 'in' operator to search for 'list' in undefined, que ocorre porque não devemos usar o operator 'in' em undefined
  hasListMode: state => page => state.schemes[page] && 'list' in state.schemes[page],

  actions_scheme: state => params => {
    // let { tab, page, mode, step } = params;

    // if (tab > 0 && state.schemes[page][mode].tabs) return state.schemes[page][mode].tabs.content[tab].actions;
    // if (step > 0 && state.schemes[page][mode].steps) return state.schemes[page][mode].steps.content[step].actions;

    // if (state.schemes[page]) return state.schemes[page][mode].actions;

    return utils.getActionsScheme(state, params);
  },

  model: state => params => {
    if (state.models[params.page]) {
      return state.models[params.page][params.mode];
    } else {
      return params.mode === 'list' ? [] : {};
    }
  },

  modelValue: state => params => {
    if (state.models[params.page]) {
      if (params.mode === 'list' && params.index) {
        const list = state.models[params.page][params.mode];
        if (Array.isArray(list) && !list.length) {
          return undefined;
        }

        return state.models[params.page][params.mode][params.index][params.field];
      } else {
        return state.models[params.page][params.mode][params.field];
      }
    }
  },

  defaultFilter: state => state.defaultFilter,

  pageFilter: state => page => state.pageFilter[page],

  wrapperPageConfig: state => page => state.schemes[page]?.wrapperPageConfig
};
